module.exports = __webpack_public_path__ + "img/media (18).55f52a50.png";